import startCase from 'lodash/startCase';
import toLower from 'lodash/toLower';

import { Tag, TagGroup } from '@backstage/ui';

import styles from './StateTag.module.css';

const SUCCESS_STATES = new Set([
  'active',
  'live',
  'completed',
  'allocated',
  'ok',
]);
const WARNING_STATES = new Set([
  'draft',
  'pending',
  'running',
  'unallocated',
  'in_review',
]);
const DANGER_STATES = new Set(['aborted', 'failed', 'error', 'rejected']);

const normalizeState = (state: string) =>
  state.replace(/^STATE_/, '').toLowerCase();

const getColorClass = (state: string): string | undefined => {
  const normalized = normalizeState(state);
  if (SUCCESS_STATES.has(normalized)) return styles.success;
  if (WARNING_STATES.has(normalized)) return styles.warning;
  if (DANGER_STATES.has(normalized)) return styles.danger;
  return undefined;
};

interface StateTagProps {
  state: string;
}

export const StateTag = ({ state }: StateTagProps) => {
  const label = startCase(toLower(state));
  return (
    <TagGroup aria-label={label}>
      <Tag
        id={state}
        textValue={label}
        size="small"
        className={getColorClass(state)}
      >
        {label}
      </Tag>
    </TagGroup>
  );
};
